import * as React from "react";
function SvgBubbleDollar(
  props: React.SVGProps<SVGSVGElement>,
  svgRef?: React.Ref<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        d="M13 7H3a2 2 0 00-2 2v14a2 2 0 002 2h16l6 6v-6h4a2 2 0 002-2V9a2 2 0 00-2-2h-2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
      <path
        d="M18.17 17.83A4 4 0 1021 11a4 4 0 112.82-6.83M21 1v20"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="currentColor"
      />
    </svg>
  );
}
const ForwardRef = React.forwardRef(SvgBubbleDollar);
const MemoForwardRef = React.memo(ForwardRef);
export default MemoForwardRef;
